import React, { useState } from 'react';
import { Modal } from './ui/Modal';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-[#0a1628] border-t border-[#1e3a5f]/30 py-8" data-id="element-22">
        <div className="max-w-4xl mx-auto px-6" data-id="element-23">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-24">
            <p className="text-gray-500 text-sm" data-id="element-25">
              © {new Date().getFullYear()} Hábitos Atómicos Espirituales. Todos
              los derechos reservados.
            </p>

            <div className="flex items-center gap-6 text-sm" data-id="element-26">
              <button onClick={() => setShowPrivacy(true)} className="text-gray-400 hover:text-[#d4af37] transition-colors" data-id="element-27">
                Política de Privacidad
              </button>
              <button onClick={() => setShowTerms(true)} className="text-gray-400 hover:text-[#d4af37] transition-colors" data-id="element-28">
                Términos y Condiciones
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-29">
        <div className="space-y-6" data-id="element-30">
          <section data-id="element-31">
            <h3 className="text-xl font-semibold text-white mb-3" data-id="element-32">
              1. Información que Recopilamos
            </h3>
            <p data-id="element-33">
              En Hábitos Atómicos Espirituales, recopilamos únicamente la
              información necesaria para procesar tu compra y entregarte el
              producto digital. Esto incluye:
            </p>
            <ul className="list-disc list-inside mt-2 space-y-1 ml-4" data-id="element-34">
              <li data-id="element-35">Nombre y dirección de correo electrónico</li>
              <li data-id="element-36">
                Información de pago (procesada de forma segura por nuestro
                proveedor de pagos)
              </li>
            </ul>
          </section>

          <section data-id="element-37">
            <h3 className="text-xl font-semibold text-white mb-3" data-id="element-38">
              2. Uso de la Información
            </h3>
            <p data-id="element-39">Utilizamos tu información para:</p>
            <ul className="list-disc list-inside mt-2 space-y-1 ml-4" data-id="element-40">
              <li data-id="element-41">Procesar tu compra y entregarte acceso al producto</li>
              <li data-id="element-42">Enviarte actualizaciones importantes sobre tu compra</li>
              <li data-id="element-43">Mejorar nuestros productos y servicios</li>
            </ul>
          </section>

          <section data-id="element-44">
            <h3 className="text-xl font-semibold text-white mb-3" data-id="element-45">
              3. Protección de Datos
            </h3>
            <p data-id="element-46">
              Nos comprometemos a proteger tu información personal. No vendemos,
              alquilamos ni compartimos tu información con terceros, excepto
              cuando sea necesario para procesar tu compra (procesadores de
              pago).
            </p>
          </section>

          <section data-id="element-47">
            <h3 className="text-xl font-semibold text-white mb-3" data-id="element-48">
              4. Cookies
            </h3>
            <p data-id="element-49">
              Utilizamos cookies esenciales para el funcionamiento del sitio web
              y para mejorar tu experiencia de usuario.
            </p>
          </section>

          <section data-id="element-50">
            <h3 className="text-xl font-semibold text-white mb-3" data-id="element-51">
              5. Tus Derechos
            </h3>
            <p data-id="element-52">
              Tienes derecho a acceder, corregir o eliminar tu información
              personal en cualquier momento. Para ejercer estos derechos,
              contáctanos directamente.
            </p>
          </section>

          <section data-id="element-53">
            <h3 className="text-xl font-semibold text-white mb-3" data-id="element-54">
              6. Cambios a esta Política
            </h3>
            <p data-id="element-55">
              Nos reservamos el derecho de actualizar esta política de
              privacidad. Te notificaremos sobre cambios significativos por
              correo electrónico.
            </p>
          </section>
        </div>
      </Modal>

      {/* Terms and Conditions Modal */}
      <Modal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-56">
        <div className="space-y-6" data-id="element-57">
          <section data-id="element-58">
            <h3 className="text-xl font-semibold text-white mb-3" data-id="element-59">
              1. Aceptación de Términos
            </h3>
            <p data-id="element-60">
              Al comprar y utilizar Hábitos Atómicos Espirituales, aceptas estos
              términos y condiciones en su totalidad. Si no estás de acuerdo,
              por favor no realices la compra.
            </p>
          </section>

          <section data-id="element-61">
            <h3 className="text-xl font-semibold text-white mb-3" data-id="element-62">
              2. Descripción del Producto
            </h3>
            <p data-id="element-63">
              Hábitos Atómicos Espirituales es un producto digital que incluye:
            </p>
            <ul className="list-disc list-inside mt-2 space-y-1 ml-4" data-id="element-64">
              <li data-id="element-65">Ebook en formato PDF con el sistema completo</li>
              <li data-id="element-66">Audiolibro en formato MP3</li>
              <li data-id="element-67">Habit Tracker en formato imprimible y digital</li>
            </ul>
          </section>

          <section data-id="element-68">
            <h3 className="text-xl font-semibold text-white mb-3" data-id="element-69">
              3. Entrega del Producto
            </h3>
            <p data-id="element-70">
              El acceso al producto digital se entrega inmediatamente después de
              completar la compra, a través del correo electrónico
              proporcionado. Es tu responsabilidad verificar que el correo sea
              correcto.
            </p>
          </section>

          <section data-id="element-71">
            <h3 className="text-xl font-semibold text-white mb-3" data-id="element-72">
              4. Garantía de Satisfacción
            </h3>
            <p data-id="element-73">
              Ofrecemos una garantía de satisfacción de 30 días. Si no estás
              satisfecho con el producto, puedes solicitar un reembolso completo
              dentro de los primeros 30 días después de la compra.
            </p>
          </section>

          <section data-id="element-74">
            <h3 className="text-xl font-semibold text-white mb-3" data-id="element-75">
              5. Propiedad Intelectual
            </h3>
            <p data-id="element-76">
              Todo el contenido de Hábitos Atómicos Espirituales está protegido
              por derechos de autor. Al comprar el producto, obtienes una
              licencia personal e intransferible para uso individual. No está
              permitido:
            </p>
            <ul className="list-disc list-inside mt-2 space-y-1 ml-4" data-id="element-77">
              <li data-id="element-78">Compartir, revender o distribuir el contenido</li>
              <li data-id="element-79">Modificar o crear obras derivadas sin autorización</li>
              <li data-id="element-80">Usar el contenido con fines comerciales sin permiso</li>
            </ul>
          </section>

          <section data-id="element-81">
            <h3 className="text-xl font-semibold text-white mb-3" data-id="element-82">
              6. Limitación de Responsabilidad
            </h3>
            <p data-id="element-83">
              Este producto es una herramienta educativa y de desarrollo
              personal. Los resultados pueden variar según el compromiso
              individual. No garantizamos resultados específicos y no somos
              responsables por el uso que hagas del contenido.
            </p>
          </section>

          <section data-id="element-84">
            <h3 className="text-xl font-semibold text-white mb-3" data-id="element-85">
              7. Modificaciones
            </h3>
            <p data-id="element-86">
              Nos reservamos el derecho de actualizar estos términos en
              cualquier momento. Los cambios entrarán en vigor inmediatamente
              después de su publicación.
            </p>
          </section>

          <section data-id="element-87">
            <h3 className="text-xl font-semibold text-white mb-3" data-id="element-88">
              8. Contacto
            </h3>
            <p data-id="element-89">
              Para cualquier pregunta sobre estos términos, puedes contactarnos
              a través del correo electrónico proporcionado en tu confirmación
              de compra.
            </p>
          </section>
        </div>
      </Modal>
    </>;
}